interface ViewableMessagePhoto {
  expires_at: string
  thumb_url: string
  url: string
  fe_hash?: string
}

interface PendingMessagePhoto {
  thumb_url: string
  fe_hash?: string
}

interface LockedMessagePhoto {
  expires_at: string
}

interface ViewableVoiceMessage {
  expires_at: string
  url: string
  duration: number
}

interface LockedVoiceMessage {
  expires_at: string
  duration: number // seconds
}

interface MessageBase {
  boosted: boolean
  fe_message_id?: string
  is_me: boolean
  boostInProgress?: boolean
  timestamp: string
}

type TextMessage = MessageBase & {
  type: 'text'
  body: string
}

type PhotoMessage = MessageBase & {
  type: 'photo'
} & (
    | {
        status: 'viewed' | 'reported' | 'expired' | 'rejected'
      }
    | {
        status: 'locked'
        photo: LockedMessagePhoto
        unlockInProgress?: boolean
      }
    | {
        status: 'pending'
        photo: PendingMessagePhoto
      }
    | {
        status: 'viewable'
        photo: ViewableMessagePhoto
      }
  )

type VoiceMessage = MessageBase & {
  type: 'voice'
} & (
    | {
        status: 'expired'
      }
    | {
        status: 'locked'
        voice_message: LockedVoiceMessage
        unlockInProgress?: boolean
      }
    | {
        status: 'viewable'
        voice_message: ViewableVoiceMessage
      }
  )

export type Message = TextMessage | PhotoMessage | VoiceMessage

export const isFakeMessage = (message: Message) => {
  return message.fe_message_id === message.timestamp
}

export type ExpirableMessage = Message & {
  type: 'photo' | 'voice'
  status: 'viewable' | 'locked'
}

export const isExpirableMessage = (message: Message): message is ExpirableMessage => {
  return (
    (message.type === 'photo' || message.type === 'voice') &&
    (message.status === 'viewable' || message.status === 'locked')
  )
}
